import {action, observable} from 'mobx'

export default class ProfileSettingsEditState {
    @observable inputs_are_disabled = false
    @observable inputs_are_readonly = false

    @observable is_params_by_feature_builder_opened = false
    /** @type {Map<string, boolean>} */
    @observable params_by_feature_builder_selected_feature_codes = new Map()

    @action lockInputs() {
        this.inputs_are_disabled = true
        this.inputs_are_readonly = true
    }

    @action unlockInputs() {
        this.inputs_are_disabled = false
        this.inputs_are_readonly = false
    }

    @action openParamsByFeaturesBuilder() {
        this.is_params_by_feature_builder_opened = true
        this.params_by_feature_builder_selected_feature_codes = new Map()
    }

    @action closeParamsByFeaturesBuilder() {
        this.is_params_by_feature_builder_opened = false
    }

    isParamsByFeaturesBuilderOpened() {
        return this.is_params_by_feature_builder_opened
    }

    @action toggleParamsByFeaturesBuilderFeature(feature_code, toggle) {
        if (toggle) {
            this.params_by_feature_builder_selected_feature_codes.set(feature_code, true)
        } else {
            this.params_by_feature_builder_selected_feature_codes.delete(feature_code)
        }
    }

    isParamsByFeaturesBuilderFeatureSelected(feature_code) {
        return this.params_by_feature_builder_selected_feature_codes.has(feature_code)
    }

    getParamsBuilderSelectedFeatureCodes() {
        return Array.from(this.params_by_feature_builder_selected_feature_codes.keys())
    }
}